import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const getSidebarUpsell = async () => {
    try {
        const { data, error, response } = await webserveruserClient.GET('/rest/sidebar/upsell/', 'get sidebar upsell', {
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data?.upsell_information ?? null;
    }
    catch (error) {
        logger.error('Error getting sidebar upsell', {
            error,
        });
        return null;
    }
};
//# sourceMappingURL=getSidebarUpsell.js.map